import {
  BuyerCompany,
  ConversationContact,
  EnhancedConversationContact,
  EnhancedConversationContactAggregated,
  Marketplace,
  SellerCompany,
} from 'src/types'
import { findById } from 'src/utils'

interface EnhancedConversationContactArgs {
  contact: EnhancedConversationContact
  currentUserMarketplaces: Marketplace[]
}

export const enhanceConversationContact = ({
  contact,
  currentUserMarketplaces,
}: EnhancedConversationContactArgs): EnhancedConversationContactAggregated => ({
  id: contact.id,
  marketplace: findById(currentUserMarketplaces)(contact.marketplaceId),
  name: contact.name,
})

interface FormatConversationContactsArgs {
  contacts: ConversationContact[]
  currentMarketplaceId?: Id
  marketplaces?: Marketplace[]
}

export const formatConversationContacts = ({
  contacts,
  marketplaces = [],
  currentMarketplaceId,
}: FormatConversationContactsArgs) =>
  contacts
    .reduce((acc, contact) => {
      const extractedContacts =
        contact.marketplaceIds.length > 0
          ? contact.marketplaceIds.map(marketplaceId => ({
              id: contact.id,
              marketplaceId,
              name: contact.name,
            }))
          : [{ id: contact.id, marketplaceId: currentMarketplaceId, name: contact.name }]
      return [...acc, ...extractedContacts]
    }, [] as EnhancedConversationContact[])
    .map(contact => enhanceConversationContact({ contact, currentUserMarketplaces: marketplaces }))

export const transformCompanyToContact = (
  company: BuyerCompany | SellerCompany
): ConversationContact => ({
  id: company.id,
  marketplaceIds: (company as BuyerCompany).marketplaceIds || [],
  name: company.name,
})
